// @ts-expect-error Untyped module
import WarningsAndSuggestionsPanel from '../../modals/WarningsAndSuggestionsPanel';
import UnpublishConfirmModal from '../../modals/UnpublishConfirmModal';
import SchedulingOptionsModal from '../../publishing/modals/SchedulingOptionsModal';
import CancelScheduleConfirmModal from '../../publishing/modals/schedulingOptions/CancelScheduleConfirmModal';
import { PublishActionModalNames } from '../../publishing/types/publishButtonTypes';
import PublishConfirmModal from './PublishConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorPublishButtonActionModals = ({
  publishErrors,
  publishWarnings,
  publishInfos,
  onIssueClick,
  buttonTextKey,
  schedulingOptionsModalProps = {},
  setCancelScheduleModalType,
  cancelScheduleModalType,
  confirmPublishActionProps = {},
  publish,
  unpublish,
  schedulePublishUnpublish,
  openModalName,
  openModal,
  closeModal,
  unpublishFooter,
  publishFooter,
  getSchedulePublishDescription,
  confirmScheduleButtonTextKey
}) => {
  switch (openModalName) {
    case PublishActionModalNames.PUBLISH_CONFIRM:
      return /*#__PURE__*/_jsx(PublishConfirmModal, {
        publishButtonTextKey: buttonTextKey,
        confirmPublishActionProps: confirmPublishActionProps,
        publish: publish,
        closeModal: closeModal,
        schedulePublishUnpublish: schedulePublishUnpublish
      });
    case PublishActionModalNames.UNPUBLISH_CONFIRM:
      return /*#__PURE__*/_jsx(UnpublishConfirmModal, {
        onClose: closeModal,
        unpublish: unpublish,
        unpublishFooter: unpublishFooter
      });
    case PublishActionModalNames.SCHEDULING_OPTIONS:
      return /*#__PURE__*/_jsx(SchedulingOptionsModal, {
        publish: publish,
        schedulePublishUnpublish: schedulePublishUnpublish,
        closeModal: closeModal,
        openCancelScheduleConfirmModal: modalType => {
          setCancelScheduleModalType(modalType);
          openModal(PublishActionModalNames.CANCEL_SCHEDULE);
        },
        schedulingOptionsModalProps: schedulingOptionsModalProps,
        getSchedulePublishDescription: getSchedulePublishDescription,
        unpublishFooter: unpublishFooter,
        publishFooter: publishFooter,
        confirmScheduleButtonTextKey: confirmScheduleButtonTextKey
      });
    case PublishActionModalNames.CANCEL_SCHEDULE:
      return /*#__PURE__*/_jsx(CancelScheduleConfirmModal, {
        closeModal: closeModal,
        actionTypeBodyInfoKey: cancelScheduleModalType
      });
    case PublishActionModalNames.WARNINGS_AND_SUGGESTIONS:
      return /*#__PURE__*/_jsx(WarningsAndSuggestionsPanel, {
        errorLabels: publishErrors,
        warningLabels: publishWarnings,
        infoLabels: publishInfos,
        onClose: closeModal,
        onIssueClick: (target, onClickData) => onIssueClick({
          target,
          onClickData
        })
      });
    default:
      return null;
  }
};
export default EditorPublishButtonActionModals;